import React, { useState, useContext, useEffect } from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { AuthContext, LangContext } from "../../../context/AppContext";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { api_get_account } from "../../../api/profile/setting";
import { api_get_languages } from "../../../api/language";

const Sidebar = ({
	show,
	handleClose,
	showLoginPage,
	setShowLoginPage,
	activeTab,
}) => {
	const { isLoggedIn, handleLogin, handleLogout, Patientid } =
		useContext(AuthContext);
	const [languageOptions, setLanguageOptions] = useState([]);
	const { selectedLanguage, handleLanguageChange } = useContext(LangContext);

	const [isExpanded, setIsExpanded] = useState(false);
	const [activeLink, setActiveLink] = useState(null);
	const [profilePic, setProfilePic] = useState([]);
	const [showSearches, setShowSearches] = useState(false);
	const [searchClick, setSearchClick] = useState(false);
	const [expandedSubList, setExpandedSubList] = useState(null);

	const fetchLanguage = async () => {
		try {
			const res = await api_get_languages();
			if (res.status) {
				setLanguageOptions(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleSearchClick = () => {
		setShowSearches(!showSearches);
		setSearchClick(true);
	};

	const handleButtonClick = () => {
		setShowLoginPage(!showLoginPage);
		handleClose();
	};

	const handleProfileClick = () => {
		setIsExpanded(!isExpanded);
	};

	const handleLinkClick = (index) => {
		setActiveLink(index);
		handleClose();
	};

	const handleSubListToggle = (index) => {
		setExpandedSubList(expandedSubList === index ? null : index);
	};

	const links = [
		{ label: "Home", path: "/home" },
		{ label: "Hospitals", path: "/our-hospitals" },
		{ label: "Doctors", path: "/doctor" },
		{ label: "Excellence Centres", path: "https://coe.kpjhealth.com.my/" },
		{ label: "Our Speciality Centres", path: "/speciality-centre" },
		{ label: "KPJ Cares", path: "/kpj-cares-card-program" },
		{ label: "Campaigns & Promotions", path: "/campaigns-promotions" },
		{ label: "Events", path: "/events" },
		{ label: "Apply for GL", path: "/gl-application" },
		{ label: "Healthshoppe", path: "https://healthshoppe.com.my/" },
		{ label: "Mayo Clinic Care Network", path: "/mccn/our-collaboration" },
	];

	const corporateLinks = [
		{
			label: "Corporate Profile",
			path: "",
			subList: [
				{
					label: "Who We Are",
					path: "https://kpj.listedcompany.com/profile.html",
				},
				{
					label: "Board of Directors",
					path: "https://kpj.listedcompany.com/directors.html#directors",
				},
				{
					label: "Senior Management Team",
					path: "https://kpj.listedcompany.com/directors.html#managements",
				},
				{
					label: "Group Corporate Structure",
					path: "https://kpj.listedcompany.com/directors.html#structure",
				},
			],
		},
		{
			label: "Investor Relations",
			path: "",
			subList: [
				{ label: "Overview", path: "https://kpj.listedcompany.com/home.html" },
				{
					label: "Bursa Announcements",
					path: "https://kpj.listedcompany.com/newsroom.html",
				},
				{
					label: "Corporate Governance",
					path: "https://kpj.listedcompany.com/corporate_governance.html",
				},
				{
					label: "Stock Information",
					path: "https://kpj.listedcompany.com/stock_fundamentals.html",
				},
				{
					label: "Financials Information",
					path: "https://kpj.listedcompany.com/financials.html",
				},
				{
					label: "Information Request",
					path: "https://kpj.listedcompany.com/email_alerts.html",
				},
			],
		},
		{
			label: "Sustainability",
			path: "",
			subList: [
				// { label: "Our Sustainability", path: "https://kpj.listedcompany.com/sustainability.html" },
				// { label: "Our Sustainability Activities", path: "https://kpj.listedcompany.com/sustainability.html" },
				{
					label: "Our Sustainability Reporting",
					path: "https://kpj.listedcompany.com/sustainability.html",
				},
				// { label: "E-learning", path: "https://kpj.listedcompany.com/sustainability.html" }
			],
		},
		{
			label: "Corporate Responsibility",
			path: "",
			subList: [
				{ label: "CSR Initiatives", path: "/csr" },
				{ label: "Klinik Waqaf An-Nur", path: "/klinik-wakaf-an-nur" },
			],
		},
		{ label: "News", path: "/news" },
		{ label: "Careers", path: "/career" },
		{ label: "Procurement", path: "/procurement" },
		{ label: "K.R.A.F.T. Challenge", path: "/innovationcampaign" },
		{ label: "KPJ Health System", path: "https://kpjhealthsystem.com.my/" },
	];

	const displayedLinks = activeTab === "Corporate" ? corporateLinks : links;

	// const languageOptions = [
	//   { value: "en", label: "EN", image: "./../img/icon/lang.png" },
	//   { value: "cn", label: "CN", image: "./../img/icon/china.png" },
	//   { value: "bm", label: "BM", image: "./../img/icon/malaysia.png" },
	// ];

	const get_account = () => {
		api_get_account()
			.then((res) => {
				if (res?.data) {
					setProfilePic(res.data.data.account.profile_image);
				}
			})
			.catch((err) => {
				console.error("Error fetching profile image:", err);
			});
	};

	useEffect(() => {
		if (isLoggedIn || Patientid) {
			get_account();
		}
	}, [isLoggedIn, Patientid]);

	useEffect(() => {
		fetchLanguage();
	}, []);

	return (
		<Offcanvas
			show={show}
			onHide={handleClose}
			placement="end"
			className="side__bar"
		>
			<OffcanvasHeader>
				{isLoggedIn || Patientid ? (
					<div style={{ marginBottom: "15px" }}>
						<div
							onClick={handleProfileClick}
							style={{
								cursor: "pointer",
								textAlign: "center",
								color: "black",
							}}
						>
							<div style={{ display: "flex" }}>
								<img
									src={profilePic}
									alt=""
									style={{
										borderRadius: "50%",
										width: "30px",
										height: "30px",
										color: "black",
										border: "2px solid #E6E5E6",
									}}
								/>
								<img
									src="./../img/icon/dropdown-icon-gray.svg"
									alt=""
									style={{ marginLeft: "10px" }}
								/>
							</div>
						</div>
						{isExpanded && (
							<ul>
								<li style={{ marginTop: "24px" }}>
									<Link
										to="/profile"
										style={{ fontSize: "16px" }}
										onClick={handleClose}
									>
										<span>
											<img
												src="./../img/icon/view-profile-mobile-icon.svg"
												alt=""
												style={{ marginRight: "10px" }}
											/>
										</span>
										View Profile
									</Link>
								</li>
								<li style={{ marginTop: "24px" }} id="mypurchasepage">
									{/* //rebranding #123 to "/purchases" */}
									<Link
										to="/purchases"
										style={{ fontSize: "16px" }}
										onClick={handleClose}
									>
										<span>
											<img
												src="./../img/icon/my-purchasese-icon.svg"
												alt=""
												style={{ marginRight: "10px", width: "24px" }}
											/>
										</span>
										My Purchases
									</Link>
								</li>
								<li
									style={{ borderTop: "1px solid white", marginTop: "24px" }}
									onClick={handleLogout}
								>
									<a href="#" style={{ fontSize: "16px" }}>
										<span>
											<img
												src="./../img/icon/logout-mobile-icon.svg"
												alt=""
												style={{ marginRight: "10px" }}
											/>
										</span>
										Log Out
									</a>
								</li>
							</ul>
						)}
					</div>
				) : (
					<button
						style={{
							backgroundColor: "transparent",
							border: "0",
							color: "black",
							cursor: "pointer",
							fontSize: "17px",
						}}
						onClick={handleButtonClick}
					>
						Login
						<span>
							<img
								src="./../img/icon/login-icon-mv.svg"
								alt=""
								style={{ marginLeft: "10px" }}
							/>
						</span>
					</button>
				)}
				<img
					src="./../img/icon/close-icon-mv.svg"
					alt=""
					onClick={handleClose}
					style={{ position: "absolute", top: "10px", right: "10px" }}
				/>
			</OffcanvasHeader>
			<OffcanvasBody>
				{!searchClick && (
					<img
						src="./../img/icon/public-search.svg"
						alt=""
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							margin: "15px",
						}}
						onClick={handleSearchClick}
					/>
				)}
				{showSearches && (
					<Link
						to="/search"
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							margin: "15px",
							borderBottom: "1px solid #606060",
						}}
						onClick={handleClose}
					>
						<button className="sidebar_search_btn">Search</button>
						<img
							src="./../img/icon/public-search.svg"
							alt=""
							style={{ width: "15px" }}
						/>
					</Link>
				)}
				<div style={{ marginBottom: "20px" }}>
					<ul>
						{displayedLinks.map((link, index) => (
							<li
								key={index}
								style={{
									backgroundColor: activeLink === index ? "#967F65" : "",
									fontSize: "14px",
								}}
							>
								{link.subList ? (
									<div>
										<div
											onClick={() => handleSubListToggle(index)}
											style={{
												cursor: "pointer",
												color: activeLink === index ? "white" : "black",
												display: "flex",
												justifyContent: "space-between",
											}}
										>
											{link.label}
											<img
												src="./../img/icon/dropdown-icon-gray.svg"
												alt=""
												style={{
													transform:
														expandedSubList === index
															? "rotate(180deg)"
															: "rotate(0deg)",
												}}
											/>
										</div>
										{expandedSubList === index && (
											<ul style={{ paddingLeft: "20px" }}>
												{link.subList.map((subItem, subIndex) =>
													subItem.path.startsWith("https") ? (
														<li key={subIndex}>
															<a
																href={subItem.path}
																rel="noopener noreferrer"
																style={{
																	fontSize: "15px",
																	fontWeight: "500",
																	color: "#647589",
																	textDecoration: "none",
																}}
															>
																{subItem.label}
															</a>
														</li>
													) : (
														<li key={subIndex}>
															<Link
																to={subItem.path}
																onClick={handleClose}
																style={{
																	fontSize: "15px",
																	fontWeight: "500",
																	color: "#647589",
																}}
															>
																{subItem.label}
															</Link>
														</li>
													)
												)}
											</ul>
										)}
									</div>
								) : (
									<Link
										to={link.path}
										onClick={() => handleLinkClick(index)}
										style={{ color: activeLink === index ? "white" : "" }}
									>
										{link.label}
									</Link>
								)}
							</li>
						))}
					</ul>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						padding: "0 15px",
					}}
				>
					<a
						href="https://www.facebook.com/KPJHealthcareOfficial/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<FacebookIcon sx={{ color: "black" }} />
					</a>
					<a
						href="https://www.instagram.com/kpjhealthcareberhadofficial/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<InstagramIcon sx={{ color: "black" }} />
					</a>
					<a
						href="https://twitter.com/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<TwitterIcon sx={{ color: "black" }} />
					</a>
					<a
						href="https://www.linkedin.com/company/kpj-healthcare-bhd/"
						target="_blank"
						rel="noopener noreferrer"
					>
						<LinkedInIcon sx={{ color: "black" }} />
					</a>
					<a
						href="https://www.youtube.com/@kpjhealthcaretv"
						target="_blank"
						rel="noopener noreferrer"
					>
						<YouTubeIcon sx={{ color: "black" }} />
					</a>
				</div>
				<div className="d-none" style={{ padding: "15px" }}>
					{languageOptions.map((option) =>
						option.language_code === selectedLanguage ? (
							<img
								key={option.language_code}
								className="lang"
								src={option.language_image}
								alt=""
								style={{ width: "6%" }}
							/>
						) : null
					)}
					<select
						value={selectedLanguage}
						onChange={(e) => handleLanguageChange(e.target.value)}
						style={{
							border: "0",
							backgroundColor: "transparent",
							color: "black",
						}}
					>
						{languageOptions.map((option) => (
							<option
								key={option.language_code}
								value={option.language_code}
								style={{ color: "black" }}
							>
								{option.language_code.toUpperCase()}
							</option>
						))}
					</select>
				</div>
			</OffcanvasBody>
		</Offcanvas>
	);
};

export default Sidebar;
